import { API_URL } from './application';

export const CALCULATE_LOAN_OFFER = 'CALCULATE_LOAN_OFFER';
export const REQUEST_CALCULATE_LOAN_OFFER_DETAILS = 'REQUEST_CALCULATE_LOAN_OFFER_DETAILS';
export const RECEIVE_CALCULATE_LOAN_OFFER_DETAILS = 'RECEIVE_CALCULATE_LOAN_OFFER_DETAILS';
const GET_APPLICATION_DETAILS_URL = API_URL+'api/Applications/OfferPmtDetails';


export function GetFetchOffer(amt, len, due, free) {   
    // due = 0, duedate eom, due = 1, duedate = 15th
    let val = parseFloat((amt / len) + 10).toFixed(2);
    return (dispatch) => {
        dispatch({type: CALCULATE_LOAN_OFFER, amt,len,monthlyPmt:val});
        dispatch(GetApplicationOfferDetails({len: len, amt: amt, due: due, free :free }))
    }
}

// Invoice financing specific function that doesn't call GetApplicationOfferDetails
export function GetFetchOfferForInvoiceFinancing(amt, len, due, free) {   
    let val = parseFloat((amt / len) + 10).toFixed(2);
    return (dispatch) => {
        dispatch({type: CALCULATE_LOAN_OFFER, amt,len,monthlyPmt:val});
        // Note: No GetApplicationOfferDetails call for invoice financing
    }
}

export function GetApplicationOfferDetails(application) {
    let due = application.due;
    if (due == undefined) 
        due = 1;
    let free = application.free;
    if (free == undefined)
        free = 0;
    return (dispatch) => {
        dispatch({type: REQUEST_CALCULATE_LOAN_OFFER_DETAILS});    

                return fetch(GET_APPLICATION_DETAILS_URL, {
                    method: 'POST',
                    headers: {           
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({                        
                            LoanLength: application.len,
                            LoanRate: 24,
                            LoanDueDate: due,
                            LoanAmount: application.amt,
                            capitalFreeMonths: free,
                            })
                }). then (
                    response => {
                        return response.json() 
                    }).then (
                            response => {
                                return dispatch ({ type: RECEIVE_CALCULATE_LOAN_OFFER_DETAILS, 
                                    response})
                            }
                        )
    }
}